// See auth.ts for why the context and hook live apart from the provider.
import { createContext, useContext } from 'react'
import type { FolderNode, Collection } from '../types/fileManager'

export interface FileManagerContextType {
  activeProjectId: string | null
  folderTree: FolderNode[]
  rootFolderId: number | null
  selectedFolderId: number | null
  setSelectedFolderId: (id: number | null) => void
  refreshTree: () => Promise<void>
  treeLoading: boolean
  collections: Collection[]
  activeCollectionId: number | null
  setActiveCollectionId: (id: number | null) => void
  refreshCollections: () => Promise<void>
}

export const FileManagerContext = createContext<FileManagerContextType>({
  activeProjectId: null,
  folderTree: [],
  rootFolderId: null,
  selectedFolderId: null,
  setSelectedFolderId: () => {},
  refreshTree: async () => {},
  treeLoading: false,
  collections: [],
  activeCollectionId: null,
  setActiveCollectionId: () => {},
  refreshCollections: async () => {},
})

export function useFileManager() {
  return useContext(FileManagerContext)
}
